module.exports = __webpack_public_path__ + "static/media/att-profile.aab0e50d.svg";